import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);
    this.setState({ errorInfo });
  }

  reset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 40,
          background: '#f8fafc',
          fontFamily: 'Inter, sans-serif'
        }}>
          <div style={{
            maxWidth: 720,
            width: '100%',
            background: '#fff',
            borderRadius: 0,
            padding: 32,
            border: '2px solid #ef4444',
            boxShadow: '0 4px 24px rgba(239,68,68,.1)'
          }}>
            <h1 style={{ fontSize: 24, fontWeight: 800, color: '#01579b', marginBottom: 16 }}>
              Something went wrong
            </h1>
            <p style={{ color: '#475569', marginBottom: 16, fontSize: 14 }}>
              The page crashed while rendering. Below is the error trace — copy and send it to support if it persists.
            </p>
            <pre style={{
              background: '#1e293b',
              color: '#f1f5f9',
              padding: 16,
              borderRadius: 4,
              fontSize: 12,
              overflow: 'auto',
              maxHeight: 320,
              fontFamily: 'JetBrains Mono, monospace'
            }}>
              {(this.state.error?.message || 'Unknown error') + '\n\n' + (this.state.error?.stack || '')}
            </pre>
            <div style={{ marginTop: 16, display: 'flex', gap: 12 }}>
              <button
                onClick={this.reset}
                style={{
                  background: '#0071e3',
                  color: '#fff',
                  border: 'none',
                  padding: '10px 20px',
                  fontWeight: 600,
                  cursor: 'pointer'
                }}>
                Try again
              </button>
              <button
                onClick={() => window.location.href = '/admin/login'}
                style={{
                  background: '#fff',
                  color: '#01579b',
                  border: '1px solid #cbd5e1',
                  padding: '10px 20px',
                  fontWeight: 600,
                  cursor: 'pointer'
                }}>
                Back to login
              </button>
              <button
                onClick={() => window.location.href = '/'}
                style={{
                  background: '#fff',
                  color: '#475569',
                  border: '1px solid #cbd5e1',
                  padding: '10px 20px',
                  fontWeight: 600,
                  cursor: 'pointer'
                }}>
                Home
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
